<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconPlus_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M19.071 13a1 1 0 1 0 0-2H13V4.929a1 1 0 1 0-2 0V11H4.929a1 1 0 1 0 0 2h6.07v6.071a1 1 0 1 0 2 0V13h6.072Z"
        clip-rule="evenodd"
    />
</svg>
